import { lazy, type ComponentType } from 'react';

const RELOAD_STORAGE_KEY = 'sb-chunk-reload-attempted';

const shouldRetryError = (error: unknown): boolean => {
  if (!(error instanceof Error)) return false;
  const message = error.message || '';
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    message.includes('error loading dynamically imported module') ||
    message.includes('Unable to preload CSS')
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const lazyWithRetry = <T extends ComponentType<any>>(importFn: () => Promise<{ default: T }>) =>
  lazy<T>(async () => {
    const alreadyReloaded = sessionStorage.getItem(RELOAD_STORAGE_KEY) === 'true';

    try {
      return await importFn();
    } catch (error) {
      if (shouldRetryError(error) && !alreadyReloaded) {
        sessionStorage.setItem(RELOAD_STORAGE_KEY, 'true');
        window.location.reload();
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
